$(document).ready(function(){
  
     
    $("a.search-btn").click(function(){
         $('.form-field').toggleClass('hide');
    });

    $('.search-modal__content').click(function(e){
      e.stopPropagation();
    })

     $(".menu-icon").click(function(){
         $('nav').toggleClass('show');
    });

    $("header .header__icon--search").click(function(e){
      e.stopPropagation();
      $('body').addClass('search-open')
    })
    $('.search-modal__close-button').click(function(e){
      
      $('body').removeClass('search-open')
    })

    $(document).click(function(){
      $('body').removeClass('search-open')
      
    })

    

     let sliderInterval;
      const totalSlides = $(".slide").length;
      let currentIndex = 0;

      $("#total").text(totalSlides.toString().padStart(2,'0'));

      function goToSlide(index){
        if(index === currentIndex) return;
        //console.log(index, currentIndex)
        
        $(".slide").eq(currentIndex).stop(true, true).fadeOut(500).removeClass("active");
        $(".slide").eq(index).stop(true, true).fadeIn(500).addClass("active");
        
        $("#current").text((index+1).toString().padStart(2,'0'));
        $(".nav-dots span").removeClass("active");
        $(`.nav-dots span[data-index='${index}']`).addClass("active");
        currentIndex = index;
       // console.log(currentIndex)
      }

      function startSlider(){
        // prevent multiple intervals
        if(sliderInterval) return;

        sliderInterval = setInterval(() => {
          let index = currentIndex + 1;
          if(index >= totalSlides){
            index = 0;
          }
          goToSlide(index);
        }, 5000);
}


      function stopSlider(){
        clearInterval(sliderInterval);
        sliderInterval = null;
      }
      $(document).ready(() => {
        startSlider();
      });

      $(window).on("beforeunload", () => {
        stopSlider();
      });

      function onRouteChange(route){
        if(route === "index"){
          startSlider();
        } else {
          stopSlider();
        }
      }






      // $(".nav-dots span").click(function(){
      //   let index = $(this).data("index");
      //   //console.log(index)
      //   goToSlide(index);
      // });

      $(window).resize(function(){
        // No special action needed on resize
      });
    });




    $(document).ready(function () {
  $(".thumbnails img").click(function () {
    // Get the clicked thumbnail's base image URL (strip width param)
    let thumbSrc = $(this).attr("src");
    let baseSrc = thumbSrc.split("?")[0]; // remove query string
    let version = thumbSrc.match(/v=\d+/); // preserve version if present
    let versionParam = version ? "?" + version[0] : "";

    // Build new srcset using Shopify image widths
    let widths = [165, 360, 533, 720, 940, 1066];
    let newSrcSet = widths
      .map(function (w) {
        return `${baseSrc}${versionParam}&width=${w} ${w}w`;
      })
      .join(",") + `,${baseSrc}${versionParam} 443w`; // fallback width

    // Build new src for main image
    let newSrc = `${baseSrc}${versionParam}&width=533`;

    // Update main image
    $(this)
      .closest(".product-card")
      .find(".product-main img")
      .attr("src", newSrc)
      .attr("srcset", newSrcSet);

    // Update active class
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
  });

  // Size selector toggle
  $(".sizes span").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.querySelector('#mode-toggle');
  const sizePopup = document.querySelector('.sizeGuide-poup');
  const tabs = document.querySelectorAll('.tab-header li');
  const tableTitle = document.querySelector('.table-title')
  const sizeGuideOpener = document.querySelector('#size-guide-opener')
  const closeBtn = document.querySelector('.sizeGuide-poup .close a')
  const popOverLay= document.querySelector('.sizeGuide-poup')
  const sizeChart= document.querySelector('.size-chart')
 
  // if(sizeGuideOpener){
    
  //   sizeGuideOpener.addEventListener('click', function(){
  //    // console.log(sizeGuideOpener)
  //     document.querySelector('body').style.overflow="hidden"
  //     sizePopup.classList.add('open')
  //   })

  //   closeBtn.addEventListener('click', function(e){
  //     e.preventDefault();
  //     document.querySelector('body').style.overflow="visible"
  //     sizePopup.classList.remove('open')
  //   })

  //   popOverLay.addEventListener('click', function(){
  //     document.querySelector('body').style.overflow="visible"
  //       sizePopup.classList.remove('open')
  //   })
  //   sizeChart.addEventListener('click', function(e){
  //     e.stopPropagation();
  //   })
  
  // }
  if (!sizeGuideOpener) return;
  document.addEventListener('click', function(e){
  if(e.target.closest('#size-guide-opener')){
    document.body.style.overflow = "hidden";
    document.querySelector('.sizeGuide-poup').classList.add('open');
  }
});

    closeBtn.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('body').style.overflow="visible"
      sizePopup.classList.remove('open')
    })

    popOverLay.addEventListener('click', function(){
      document.querySelector('body').style.overflow="visible"
        sizePopup.classList.remove('open')
    })
    sizeChart.addEventListener('click', function(e){
      e.stopPropagation();
    })

   
  if (sizePopup) {
    tabs.forEach(el => {
      const tab = el.querySelector('a');
      tab.addEventListener('click', function(e){
        e.preventDefault();
        let getId = tab.getAttribute('data-id');
        let tabLabel = tab.innerText;
        //console.log(getId)
        tabs.forEach(li=>{
          li.classList.remove('active')
        })
        tab.closest('li').classList.add('active')
        let id = document.querySelector(`#${getId}`)
        //console.log(id)
        id.parentElement.querySelectorAll('.specific-table-container').forEach(el => {
          el.classList.remove('active');
        });
        id.classList.add('active');
        
        tableTitle.textContent = tabLabel
      })
      
    });

    // toggleBtn.addEventListener('change', function (e) {
    //   const toggleArea = e.target.closest('.toggle-area');
    //   const activeTable = document.querySelector('.size-tables .specific-table-container.active');

    //   if (!toggleArea || !activeTable) return;

    //   const inchToggleLabel = toggleArea.querySelector('.inch');
    //   const cmToggleLabel = toggleArea.querySelector('.cm');
    //   const inchTable = activeTable.querySelector('.inch');
    //   const cmTable = activeTable.querySelector('.cm');

    //   if (this.checked) {
       
    //     inchToggleLabel?.classList.add('active');
    //     cmToggleLabel?.classList.remove('active');
    //     inchTable?.classList.add('active');
    //     cmTable?.classList.remove('active');

    //     // Toggle area class
    //     toggleArea.classList.add('in');
    //     toggleArea.classList.remove('cm');
    //   } else {
    //     inchToggleLabel?.classList.remove('active');
    //     cmToggleLabel?.classList.add('active');

    //     inchTable?.classList.remove('active');
    //     cmTable?.classList.add('active');

    //     toggleArea.classList.remove('in');
    //     toggleArea.classList.add('cm');
    //   }
    // });
  }


  

});











    